/** 导航滚动帧事件 */
export const NAV_SCROLL_FRAME_EVENT = 'NAV_SCROLL_FRAME_EVENT';

export const NAV_SCROLL_EVENT = 'NAV_SCROLL_EVENT';

export const IS_DRAGGING_EVENT = 'IS_DRAGGING_EVENT';
